import Box from '@mui/material/Box';
import { CompetitionBoard, CompetitionBoardProps } from './CompetitionBoard';
import { GradientTypography } from '../gradients/GradientTypography';

export type LiveTournamentsProps = CompetitionBoardProps;

export const LiveTournaments = ({ competitions }: LiveTournamentsProps) => {
  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'flex-start',
        flexGrow: 1,
      }}
    >
      <GradientTypography
        variant={'h4'}
        gradientColor="primary.vertical"
        sx={{
          textTransform: 'uppercase',
          mb: 2,
        }}
      >
        Tournaments
      </GradientTypography>
      <CompetitionBoard competitions={competitions} />
    </Box>
  );
};
